import { Store } from "@/core/models";
import { JuvoTrackSession } from "../interfaces";

export interface ChannelData {
  localCanalId: string;
  store: Store;
}

export interface ChannelPayload {
  localCanalId: string;
  token: string;
}


export class ChannelEligibilityRule {
  /**
   * Evalúa si un canal cumple con las condiciones de negocio para conectarse
   */
  public static isEligible(data: JuvoTrackSession | null, store: Store | null): boolean {
    if (!data || data.length === 0) return false;
    
    const [channel] = data;
    
    if (!store?.apiKey) return false;
    if (!channel) return false;
    if (!channel?.idLocalCanal || !channel?.canalId) return false;
    if (!channel.habilitado) return false;

    return true;
  }
}